import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import OpenInNewRounded from '@mui/icons-material/OpenInNewRounded';
import GitHubIcon from '@mui/icons-material/GitHub';
import { useTranslation } from 'react-i18next';

import { PanelSection, CheckList } from './DetailPanel';

import timelinePreview from '../assets/img/timeline-preview.png';
import siaratiPreview from '../assets/img/siarati-preview.png';
import iqariPreview from '../assets/img/pcf-preview.png';

// Deep-dive content for the Business & Mobile Apps practice.
export default function BusinessApps() {
  const { t } = useTranslation();

  const caseStudies = [
    {
      title: t('appsd.cs1t'),
      description: t('appsd.cs1d'),
      imageUrl: timelinePreview,
      link: 'https://github.com/dynapage/power-platform-timeline-demo',
    },
    {
      title: t('appsd.cs2t'),
      description: t('appsd.cs2d'),
      imageUrl: siaratiPreview,
      link: 'https://www.figma.com/proto/7HKDyUs8TVdtuBkafY1coa?node-id=1%3A1150',
    },
    {
      title: t('appsd.cs3t'),
      description: t('appsd.cs3d'),
      imageUrl: iqariPreview,
      link: 'https://github.com/dynapage/pcf-azure-d365-gallery',
    },
  ];

  return (
    <Box>
      <Typography variant="body1" color="text.secondary">
        {t('apps.subtitle')}
      </Typography>

      <PanelSection title={t('apps.expertisetitle')}>
        <CheckList
          items={[
            t('apps.expertise1'),
            t('apps.expertise2'),
            t('apps.expertise3'),
            t('apps.expertise4'),
          ]}
        />
      </PanelSection>

      <PanelSection title={t('appsd.casesTitle')}>
        <Stack spacing={2.5}>
          {caseStudies.map((cs) => (
            <Card key={cs.title} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
              <CardMedia
                component="img"
                image={cs.imageUrl}
                alt={cs.title}
                sx={{
                  width: { xs: '100%', sm: 220 },
                  height: { xs: 160, sm: 'auto' },
                  objectFit: 'cover',
                  flex: 'none',
                }}
              />
              <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column' }}>
                <Typography variant="h6" component="h4" gutterBottom>
                  {cs.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                  {cs.description}
                </Typography>
                <Button
                  size="small"
                  variant="text"
                  href={cs.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  endIcon={<OpenInNewRounded sx={{ fontSize: 15 }} />}
                  sx={{ alignSelf: 'flex-start', mt: 'auto', px: 0.5 }}
                >
                  {t('appsd.open')}
                </Button>
              </Box>
            </Card>
          ))}
        </Stack>
      </PanelSection>

      <PanelSection title={t('appsd.ossTitle')}>
        <Stack spacing={1}>
          <Link
            href="https://github.com/dynapage/designer"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}
          >
            <GitHubIcon fontSize="small" /> {t('appsd.oss1')}
          </Link>
          <Link
            href="https://github.com/dynapage/IqariNodeApi"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}
          >
            <GitHubIcon fontSize="small" /> {t('appsd.oss2')}
          </Link>
        </Stack>
      </PanelSection>
    </Box>
  );
}
